import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { getCategories } from "../services/categoryService";
import { friendlyError } from "../api/api";
import EmptyState from "../components/ui/EmptyState";
import ErrorState from "../components/ui/ErrorState";
import ListSkeleton from "../components/ui/ListSkeleton";

export default function Categories() {
  const [status, setStatus] = useState("loading");
  const [categories, setCategories] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(() => {
    setStatus("loading");
    getCategories()
      .then((rows) => {
        setCategories(rows);
        setStatus(rows.length === 0 ? "empty" : "ok");
      })
      .catch((err) => {
        setErrorMessage(friendlyError(err, "Unable to load categories."));
        setStatus("error");
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="text-xl font-semibold text-neutral-900 mb-6">Categories</h1>

      {status === "loading" && <ListSkeleton rows={5} />}
      {status === "error" && <ErrorState message={errorMessage} onRetry={load} />}
      {status === "empty" && <EmptyState title="No categories found." />}

      {status === "ok" && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/shop?category=${cat.id}`}
              className="rounded-2xl border border-neutral-200 bg-white p-5 flex flex-col items-center gap-2 text-center shadow-sm hover:shadow-md transition-shadow"
            >
              <span className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-neutral-500">
                {cat.emoji || <Layers size={18} />}
              </span>
              <span className="text-sm font-medium text-neutral-900">{cat.name}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
